// Data Lab · Pipeline Workflows mirror.
// Same PipelineWorkflowsPanel used on /lara/workflows — surfaced here
// because Ops looks at this data as part of the daily Data Lab pass.
import Layout from "../../components/Layout";
import PipelineWorkflowsPanel from "../lara/PipelineWorkflowsPanel";

export default function LabWorkflows() {
  return (
    <Layout>
      <div className="space-y-4" data-testid="lab-workflows">
        <div className="text-[10px] uppercase tracking-widest text-orange-400 font-mono flex items-center gap-1.5">
          Data Lab · Pipeline Workflows
        </div>
        <PipelineWorkflowsPanel />
      </div>
    </Layout>
  );
}
